import type { OnBeforeRouteSync } from "vike/types";
import { resolveLocale } from "#/lib/i18n/detect.js";

/**
 * Resolve the active locale on every request using the 4-layer priority
 * chain (URL > cookie > Accept-Language > default). The pure logic lives in
 * `src/lib/i18n/detect.ts` so it's directly unit-testable without standing
 * up Vike's runtime; this hook is only the Vike adapter.
 *
 * The resulting `urlLogical` is the pathname with any locale prefix
 * stripped, so downstream route matching sees `/outbreak/foo` regardless of
 * whether the user hit `/outbreak/foo`, `/ar/outbreak/foo`, or
 * `/zh-cn/outbreak/foo`.
 */
export const onBeforeRoute: OnBeforeRouteSync = (pageContext) => {
  const { urlPathname } = pageContext;
  const headers = (
    pageContext as unknown as {
      headersOriginal?: Record<string, string | undefined>;
    }
  ).headersOriginal;

  const { locale, source, urlLogical } = resolveLocale({
    urlPathname,
    cookieHeader: headers?.cookie,
    acceptLanguageHeader: headers?.["accept-language"],
  });

  return {
    pageContext: {
      locale,
      localeSource: source,
      urlLogical,
    },
  } as ReturnType<OnBeforeRouteSync>;
};
